import { Typeahead } from "react-bootstrap-typeahead";
import styled from "styled-components";

export const StyledTypeahead = styled(Typeahead)``;
